import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpCancelRequestService } from '../../services/http-cancel-request.service';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class HttpRequestCancelInterceptor implements HttpInterceptor {
    excludeEndpoints: string[];

    constructor(private httpCancelService: HttpCancelRequestService) {
        this.excludeEndpoints = [];
    }

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        if (this.excludeEndpoints.includes(request.url)) {
            return next.handle(request);
        }
        return next
            .handle(request)
            .pipe(takeUntil(this.httpCancelService.onCancelPendingRequests()));
    }
}
